// Import dependencies
import React, { Component} from "react";
import TweenLite from "gsap/TweenLite";

// Import component
import {Button, Container, ScrollableContainer, Text} from "../../../../components";
import {di} from "../../../../bottle";
import PropTypes from "prop-types";

// Component
export class Sumnmary extends Component {

    static propTypes = {
        onPressButton: PropTypes.func,
    };

    static defaultProps = {
        onPressButton: () => undefined
    };

    constructor(props) {
        // call base constructor
        super(props);

        // initialize instance variables
        this.summaryList = null;

        // initialize state
        this.state = {
            bike: null,
            date: new Date().getDate()
        }
    }

    componentDidMount() {

        this._garageSubscription = di.garage.bikeChanges$
            .subscribe(bikeChanges => {
                this.setState({
                    bike: bikeChanges.bike,
                    date: new Date().getDate()
                });
            });

        this.summaryListObserver = new MutationObserver(() => {
            TweenLite.to(this.summaryList.scrollingContainer.div, 2, {scrollTo: this.summaryList.scrollingContainer.div.scrollHeight});
        });

        this.summaryListObserver.observe(this.summaryList.scrollingContainer.div, {childList: true});
    }

    componentWillUnmount() {
        // unregister the garage subscription
        if (this._garageSubscription) {
            this._garageSubscription.unsubscribe();
            this._garageSubscription = null;
        }

        this.summaryListObserver.disconnect();
    }

    _displayPrice(part) {
        const modelSku = di.garage.bikeModel.sku;
        let modelPrice = di.catalogManager.priceForPart(part.sku, modelSku);
        let price = "";
        if (modelPrice != undefined) {
            price = di.profileManager.localizePrice(modelPrice);
        } else {
            price =  di.profileManager.localizePrice(di.catalogManager.priceForPart(part.sku));
        }
        price = `${price} `;
        return price;
    }

    render() {
        // resolve inputs

        const isGlobal = (di.profileManager.region === "GBL");
        const hidePrice = di.profileManager.hidePrice() 

        const { garage, localization } = di;
        let bike;

        if (!this.state.bike) {
            bike = garage.bike;
        } else {
            bike = this.state.bike;
        }

        // render Model and engine
        const base = (
            <Container key={"model"} style={styles.sectionItem} justify="space-between">
                <Text style={styles.sectionTitle}>{localization.get("build.summary.model")}</Text>
                <Container style={styles.sectionDivider} />
                <Container style={styles.sectionItem}>
                    <Text style={styles.item} bold>{bike.model.name}</Text>
                </Container>
                <Container style={styles.sectionItem}>
                    <Text style={styles.item} bold>{bike.engine.name}</Text>
                </Container>
            </Container>
        );

        // render cosmetic parts
        const colorParts = bike.parts.filter(part => part.swatch);

        const colorItems = colorParts
            .map((p, index) => (
                <Container key={`item_${index}`}
                           style={styles.sectionItem}
                           direction="row"
                           justify="space-between"
                           alignContent="space-between"
                           alignItems="center">
                    <Text
                        style={styles.item}
                        bold>{`${p.name}${p.color ? ` (${p.color})` : null}`}
                    </Text>
                    { !hidePrice && ( 
                        <Text style={styles.item}>
                            {this._displayPrice(p)}
                        </Text> 
                    )}
                    </Container>
            ));

        const color = colorParts.length > 0 ? (
            <Container key={"color"}
                       style={styles.sectionItem}
                       justify="space-between">
                <Text style={styles.sectionTitle}>{localization.get("build.buttons.color")}</Text>
                <Container style={styles.sectionDivider} />
                {colorItems}
            </Container>

        ) : null;

        // render accessories
        const accessoryParts = bike.parts
            .filter(part => part.subcategoryId !== "Engine" && part.subcategoryId !== "Model" && !part.swatch);

        const accessoryItems = accessoryParts
            .map((p, index) => (
                <Container key={`item_${index}`}
                           style={styles.sectionItem}
                           direction="row"
                           justify="space-between"
                           alignContent="space-between"
                           alignItems="center">
                    <Text
                        style={styles.item}
                        bold>{`${p.name}${p.color ? ` (${p.color})` : ''}`}</Text>
                        {/* if p.color doesn't exist "null is showing up in the sumamry, this is a hack to fix the problem*/}
                        { !hidePrice && <Text style={styles.priceItem}>{this._displayPrice(p)}</Text> }
                </Container>
            ));

        const accessories = accessoryParts.length > 0 ? (
            <Container key={"build"}
                       style={styles.sectionItem}
                       justify="space-between">
                <Text style={styles.sectionTitle}>{localization.get("build.buttons.build")}</Text>
                <Container style={styles.sectionDivider} />
                {accessoryItems}
            </Container> ) : null;

        let localizedMonthly = "";
        let priceString = "";
        let currencyString = "";
        let rate= 0;
        let terms = 0;

        if (!isGlobal) {
            rate = di.profileManager.interestRate;
            terms = di.profileManager.terms;
            const priceValue = di.garage.getTotalPrice();
            const monthlyValue = di.garage.monthlyPrice({rate, terms}, priceValue);
            const localizedPrice = di.profileManager.localizePrice(priceValue);
            localizedMonthly = di.profileManager.localizePrice(monthlyValue);
            priceString = localizedPrice;
            currencyString = di.profileManager.currency;
            rate = di.profileManager.localizedInterestRate;
        }

        return (
            <Container justify="space-between" alignContent="space-between" style={styles.container}>
                <ScrollableContainer ref={(ref) =>  this.summaryList = ref } style={styles.summary} scrollType="vertical">
                    <Text style={styles.headerTitle} bold uppercase>{localization.get("build.summary.title")}</Text>
                    <Container style={styles.headerDivider} />
                    {base}
                    {color}
                    {accessories}
                    <Container style={{height: 72}}/>
                </ScrollableContainer>

                {
                    (!hidePrice) ?
                        <Container flex alignItems="center" style={styles.buttonContainer}>
                            <Button onClick={this.props.onPressButton} style={styles.button}>
                                <Text style={styles.buttonText} bolduppercase>
                                    {localization.get("build.summary.button")}
                                </Text>
                            </Button>
                        </Container>

                        :
                        <Button onClick={this.props.onPressButton} style={styles.button}>
                            <Text style={styles.buttonText} bolduppercase>
                                {localization.get("build.summary.button")}
                            </Text>
                        </Button>

                }

                {/* Total pricing*/}
                {
                    (!hidePrice) && (
                        <Container alignItems="center" style={styles.priceContainer}>
                        <Container style={{...styles.headerDivider, marginTop: 15, marginBottom: 10}}/>
                        <Container flex direction="row" alignItems="flex-end">
                            {
                                di.profileManager.isNA &&
                            <Container>
                                {/*<Text style={{color: "#ffffff", fontSize: 12, marginBottom: 7}}>Estimated Monthly Payment**</Text>*/}
                                <Container flex direction="row" alignItems="center">
                                    <Container flex direction="row" alignItems="baseline">
                                        <Text bold style={styles.totalPrice}>{localizedMonthly}</Text>
                                        <Text bold style={styles.currency}>{!(di.profileManager.region == "DE" || di.profileManager.region == "FR" ) ? currencyString : ""}</Text>
                                    </Container>
                                        <Text
                                            style={styles.interest}>{di.localization.get("build.summary.rateDescription", rate, terms)}</Text>
                                </Container>
                            </Container>
                            }
                            {
                                di.profileManager.isNA &&
                                <Container style={styles.verticalDivider}/>
                            }
                            <Container>
                                {/*<Text style={{color: "#ffffff", fontSize: 12, marginBottom: 7}}>Total MSRP**</Text>*/}
                                <Container flex direction="row" alignItems="center">
                                    <Container flex direction="row" alignItems="baseline">
                                        <Text bold style={styles.totalPrice}>{priceString}</Text>
                                        <Text bold style={styles.currency}>{!(di.profileManager.region == "DE" || di.profileManager.region == "FR" ) ? currencyString : ""}</Text>
                                    </Container>
                                </Container>
                            </Container>
                        </Container>
                    </Container>
                    ) 
                }
            </Container>
        )
    }
}

// styles
const styles = {
    container: {
        position: "relative",
        display: "flex",
        width: 353,
        maxWidth: 353,
        height: 510,
        backgroundColor: "rgba(0, 0, 0, 0.6)"
    },
    headerTitle: {
        display: "flex",
        justifyContent: "center",
        color: "white",
        fontSize: 22
    },
    headerDivider: {
        marginTop: 5,
        width: "100%",
        height: 1,
        backgroundColor: "#ffd200"
    },
    summary: {
        height: 438,
        paddingTop: 15,
        paddingLeft: 15,
        paddingRight: 15,
    },
    sectionTitle: {
        marginTop: 8,
        marginBottom: 2,
        color: "#9b9b9b"
    },
    sectionDivider: {
        height: 1,
        backgroundColor: "#3f3f3f"
    },
    sectionItem: {
        display: "flex",
        marginTop: 12,
    },
    item: {
        fontSize: 15,
        color: "#fff",
    },
    priceItem: {
        fontSize: 15,
        color: "#fff",
        paddingLeft: 15
    },
    buttonContainer: {
        backgroundColor: "black",
    },
    button: {
        width: 313,
        height: 42,
        margin: 15
    },
    buttonText: {
        color: "#ffffff",
    },
    priceContainer: {
        padding: "0px 20px 0px 20px",
        position: "absolute",
        bottom: 72,
        backgroundColor: "black",
        width: 353
    },
    verticalDivider: {
        height: 45,
        width: 2,
        backgroundColor: "#333333"
    },
    totalPrice: {
        display: "flex",
        alignItems: "center",
        color: "#ffffff",
        fontSize: 20,
        marginRight: 3,
        marginLeft: 5
    },
    currency: {
        display: "flex",
        alignItems: "center",
        color: "#ffffff",
        fontSize: 12
    },
    interest: {
        width: 60,
        color: "#ffffff",
        fontSize: 12,
        marginLeft: 5,
        marginRight: 5
    }
};


// WEBPACK FOOTER //
// ./src/pages/Customization/components/Summary/index.js